import React from 'react'
import { hasAvailableAction } from '../../../ui/gov-actions'

const available = (record) => hasAvailableAction(record, 'migrated')

const apiEndPoint = ({ type, type_id }) =>
  process.env.REACT_APP_API_HOST + `/api/${type}s/${type_id}/migrated`

// eslint-disable-next-line react/display-name
const form = ({ name }) => () => (
  <fieldset>Once marked, kickback will assume {name} has completed onboarding with Xplor</fieldset>
)

const migrateToXplor = ({ record }) =>
  available(record)
    ? {
      label: 'Mark as migrated',
      value: 'mark_as_migrated',
      component: form(record),
      url: apiEndPoint(record),
    }
    : null

export default migrateToXplor



// WEBPACK FOOTER //
// ./src/gov-registrations/details/gov-actions/mark-as-migrated.js